var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-hint"},[_c('div',{staticClass:"demo-dialog"},[_c('p',[_vm._v("Not part of this demo (yet).")]),_c('button',{on:{"click":_vm.onClose}},[_vm._v("Okay 🤷‍♂️")])])])}
var staticRenderFns = []

export { render, staticRenderFns }